module.exports = __webpack_public_path__ + "static/img/china-1.d8b33c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china/china-1.png
// module id = 1382
// module chunks = 1